import { get, post, uploadRequest } from "./axios";

const typeIs18_23_24 = () => {
  const type = sessionStorage.getItem("deviceType");
  return type == 18 || type == 23 || type == 24;
};

const api = {
  // 公共
  // 文件上传 只能单个文件  返回一个文件的地址
  uploadFile: (data) => uploadRequest("/iotUser-api/v1/file/upload", data),

  // 与wx强相关的配置项===========================================================================
  getWxConfig: (data) => post("/iotUser-api/wxUser/js-sdk", data),
  // 微信警报消息通知开启/关闭
  getWxSubsctrib: (data) => post("/iotUser-api/wxUser/switchNotify", data),

  // 登录模块====================================================================================
  // 账号密码登录
  doLogin: (data) => post("/iotUser-api/login/app-login", data),
  // 微信登录
  authLogin: (data) => post("/iotUser-api/wxUser/auth-login", data),
  // 微信登录
  wxLogin: (data) => post("/iotUser-api/login/wx-login", data),
  // 退出登录
  outLogin: (data) => post("/iotUser-api/login/quit", data),
  // 订阅消息
  subscript: "/iotUser-api/V1/deviceStatus/subscribe",
  // 获取用户的账号信息  账号 用户名称
  getUserAccountInfo: () => get("/iotUser-api/v1/consumer/info"),

  // 获取分页 我的 消息列表
  getMessageList: (data) => post("/iotUser-api/v1/notifyCenter/list", data),
  // 统计未读消息
  getMessageUnread: (data) =>
    get("/iotUser-api/v1/notifyCenter/countUnread", data),

  // 注册模块====================================================================================
  // 发送手机验证码
  sendPhoneCode: (data) => post("/iotUser-api/register/sendVerifyCode", data),
  // 注册
  register: (data) => post("/iotUser-api/register/submit", data),

  // 设备模块====================================================================================
  // 更新设备的相关信息
  updateDeviceInfo: (data) =>
    post("/iotUser-api/v1/gateway/update", data, "put"),
  // 绑定网关
  bingGateWay: (data) => get("/iotUser-api/v1/gateway/activate", data),
  // 绑定RTU
  bingRTU: (data) => get("/iotUser-api/v1/rtu/activate", data),
  // 获取阀门的端口
  getPortAndValae: (data) => get("/iotUser-api/v1/rtu/queryRtuValve/" + data),
  // 绑定阀门到对应的RTU上 切绑定RTU
  bindRtuValve: (data) => post("/iotUser-api/v1/rtu/bindRtuValve", data),
  // 解绑RTU
  unBindRtuValve: (data) =>
    post(
      `/iotUser-api/v1/rtu/unBindGateway?gatewayNo=${data.gatewayNo}&no=${data.no}`
    ),
  // 删除网关
  deleteGateway: (data) =>
    post(`/iotUser-api/v1/gateway/deleteGateway/${data.no}`, data),
  // 查询RTU端口和阀门之间的关系
  bingRTUInGateWay: (data) => get("/iotUser-api/v1/rtu/bindleGateway", data),
  // 查询设备
  getDeviceList: (data) =>
    get("/iotUser-api/v1/gateway/getGatewayOption", data),
  // 获取监控数据
  getLiveList: (data) =>
    get("/iotUser-api/v1/gateway/getMeteorologicalData", data),
  // 查询已经绑定的传感器
  getLiveList20: (data) =>
    get(`/iotUser-api/v1/gatewaySensor/list/${data.no}`, data),

  // 查询设备属性阈值
  getHold: (data) => post("/iotUser-api/v1/alert/getThreshold", data),
  // 设置设备属性阈值
  setHold: (data) => post("/iotUser-api/v1/alert/save", data),
  // 设备在线情况
  getDeviceOnlineState: (data) =>
    get("/iotUser-api/v1/gateway/onlineStatus", data),

  // 查网关信息
  getGatewayInfo: (data) => get("/iotUser-api/v1/gateway/info", data),
  // 查询未绑定的传感器
  getGatewaySensor: (data) => get(`/iotUser-api/v1/gatewaySensor/info/${data}`),
  // 绑定传感器
  bindSensor: (data) => post("/iotUser-api/v1/gatewaySensor/bindSensor", data),

  // 会员中心模块====================================================================================
  // 修改密码
  doChangePwd: (data) => post("/iotUser-api/v1/consumer/updatePwd", data),
  // 重置密码(需要手机验证码)
  reSetPWD: (data) => post("/iotUser-api/login/reSetPassword", data, "put"),

  // 走势图====================================================================================
  // 发送邮件
  doSendEmail: (data) => post("/iotUser-api/v1/mail/sendForCsv", data),
  // 获取雨量统计 时
  rainStaticHour: (data) => post("/iotUser-api/v1/rainfallHour/list", data),
  // 日
  rainStaticDay: (data) => post("/iotUser-api/v1/rainfallDay/list", data),
  // 月
  rainStaticMonth: (data) => post("/iotUser-api/v1/rainfallMonth/list", data),
  // 年
  rainStaticYear: (data) => post("/iotUser-api/v1/rainfallYear/list", data),

  // 查询阀门====================================================================================
  // 查询阀门
  getValaveList: (data) => post("/iotUser-api/iotValve/list", data),
  // 查询用户下所有的RTU阀门
  getAllRTUList: (data) => get("/iotUser-api/v1/eqValve/getAllRtuValve", data),
  // 查询用户下所有的网关阀门
  getAllValaveList: (data) => get("/iotUser-api/iotValve/getAllValve", data),
  // 修改阀门名称
  setValavePortName: (data) => post("/iotUser-api/v1/eqValve/update", data),
  // 阀门开/关
  setValaveDetail: (data) => post("/iotUser-api/iotValve/switch-stt", data),
  // 获取任务列表
  getValvaTaskList: (data) =>
    get("/iotUser-api/v1/valveJob/queryJobByValveId", data),
  // 新增任务
  doAddValva: (data) => post("/iotUser-api/v1/valveJob/createJob", data),
  // 编辑任务
  doEditValva: (data) => post("/iotUser-api/v1/valveJob/updateJob", data),
  // 删除任务
  doDeleteValva: (data) => get("/iotUser-api/v1/valveJob/deleteJob", data),
  // 查询一个任务
  getOneTaskDetail: (data) =>
    get("/iotUser-api/v1/valveJob/queryJobById", data),
  // 查询Rtu
  getRtuList: (data) => post("/iotUser-api/v1/rtu/rtuList", data),
  // 查询RTU的压力值信息
  getRtuPressure: (data) =>
    get("/iotUser-api/v1/rtuSensorData/refreshSensor", data),
  // 查询RTU列表中每个RTU的具体信息
  getRtuPort: (data) => post("/iotUser-api/v1/rtu/getPorts", data),
  // Rtu开关
  rtuSwitch: (data) => post("/iotUser-api/v1/rtu/switchover", data),
  // 获取摄像头的图片
  getCameraPicture: (data) => post("/iotUser-api/v1/cameraImg/listPage", data),
  // 立即拍照
  takePicture: (data) => get("/iotUser-api/v1/cameraImg/takePicture", data),

  // 我的==================================
  // 获取微信推送开关状态
  getWxPushSwitch: (data) => get("/iotUser-api/wxUser/getUserInfo", data),
  // 设置开关状态
  setWxPushSwitch: (data) => get("/iotUser-api/wxUser/switchNotify", data),
  // 查询开关次数
  getSwitchActionNum: (data) =>
    post("/iotUser-api/v1/eqValveLog/getCount", data),
  // 获取阀门开关操作时间记录
  getSwitchActionHistory: (data) =>
    post("/iotUser-api/v1/eqValveLog/listPage", data),
  // 阀门分类的列表
  getValaveClassifyList: (data) =>
    post("/iotUser-api/v1/eqValveSort/list", data),
  // 阀门系统阀门明细
  getValaveClassifyDetail: (data) =>
    post("/iotUser-api/v1/eqValveSort/listDetail", data),
  // 获取阀门设备的登录日志
  getGatewayLoginLog: (data) => post("/iotUser-api/v1/gatewayLog/list", data),

  // 灌溉统计 按月查询（其实是按年）
  getStatisticByMonth: (data) =>
    post(
      `/iotUser-api/v1/irrigationGroupLog/statisticByMonth/${data.gatewayNo}`,
      data
    ),
  // 灌溉统计 按次数查询（按某年下的某月）
  getStatisticByTimes: (data) =>
    post(
      `/iotUser-api/v1/irrigationGroupLog/statisticByTimes/${data.gatewayNo}`,
      data
    ),

  // 轮灌程序====================================================================================
  // 添加/修改分组
  addGroup: (data) => post("/iotUser-api/v1/eqValveGroup/update", data),
  // 获取分组
  getGroup: (data) => post("/iotUser-api/v1/eqValveGroup/list", data),
  // 删除分组
  delGroup: (data) => get("/iotUser-api/v1/eqValveGroup/delete", data),
  // 添加轮灌组
  addLGGroup: (data) => post("/iotUser-api/v1/rotationFlow/add", data),
  // 查询轮灌组
  getLGGroup: (data) => post("/iotUser-api/v1/rotationFlow/add", data),
  // 查询程序列表
  lgGetProgramList: (data) =>
    post("/iotUser-api/v1/irrigationProgram/list", data),
  // 添加程序
  lgAddProgram: (data) => post("/iotUser-api/v1/irrigationProgram/add", data),
  // 修改轮灌程序
  lgModifyProgram: (data) =>
    post("/iotUser-api/v1/irrigationProgram/update", data),
  // 开启程序状态 /  关闭程序状态
  lgStartStopProgram: (data) =>
    post("/iotUser-api/v1/irrigationProgram/updateActiveStt", data),
  // 立即执行
  lgStartTodoProgram: (data) =>
    get("/iotUser-api/v1/irrigationProgram/execute", data),
  // 停止程序
  lgStopTodoProgram: (data) =>
    get("/iotUser-api/v1/irrigationProgram/stopExecute", data),
  // 删除轮灌程序
  lgDeleteProgram: (data) =>
    get("/iotUser-api/v1/irrigationProgram/delete", data),
  // 轮灌组  查询网关下的传感器
  getCgqData: (data) => get("/iotUser-api/v1/gateway/sensorList", data),

  //= ====================================================================
  //= ============================轮灌程序 V2 开始==========================
  //= ====================================================================
  // 读取分组
  lgV2_getGroup: (data) =>
    post(`/iotUser-api/v1/gatewayValveGroup/getGroup?gatewayNo=${data}`),
  // 设置分组
  lgV2_setGroup: (data) =>
    post("/iotUser-api/v1/gatewayValveGroup/settingGroup", data),
  // 读取程序状态
  lgV2_getProgramStatus: (data) =>
    post(`/iotUser-api/v1/gatewayValveGroup/getGroupStatus?gatewayNo=${data}`),
  // 首页轮灌信息数据
  lgV2_getFirstScreenData: (data) => {
    return get(
      `/iotUser-api/v1/${
        typeIs18_23_24() ? "gatewayValveGroup3" : "gatewayValveGroup2"
      }/getFirstScreenData`,
      data
    );
  },
  // 读取全部阀门状态
  lgV2_getAllValveStatus: (data) =>
    post(
      `/iotUser-api/v1/gatewayValveGroup/getAllValveStatus?gatewayNo=${data}`
    ),
  // 程序控制
  lgV2_control: (no, cmd, prosId) =>
    post(
      `/iotUser-api/v1/gatewayValveGroup/controlGroup?gatewayNo=${no}&cmd=${cmd}&prosId=${prosId}`
    ),
  // 查询RTU 和 轮灌阀门的关联关系
  lgV2_getValve_rtu_relation: (no) =>
    get(`/iotUser-api/v1/gatewayValveGroup/selectGatewayValve?gatewayNo=${no}`),
  // 读取轮灌程序 列表
  lgV2_getProgram_list: (no) => {
    return get(
      `/iotUser-api/v1/${
        typeIs18_23_24() ? "gatewayValveGroup3" : "gatewayValveGroup2"
      }/getProgramList?gatewayNo=${no}`
    );
  },
  // 设置程序名称
  lgV2_setProgram_name: (data) => {
    return post("/iotUser-api/v1/gatewayValveGroup2/setProgramName", data);
  },

  // 读取分组
  lgV3_getProgram_list: (no) => {
    return get(
      `/iotUser-api/v1/${
        typeIs18_23_24() ? "gatewayValveGroup3" : "gatewayValveGroup2"
      }/getProgramList?gatewayNo=${no}`
    );
  },
  // 读取程序状态
  lgV3_getProgramStatus: (data) => {
    return get(
      `/iotUser-api/v1/${
        typeIs18_23_24() ? "gatewayValveGroup3" : "gatewayValveGroup2"
      }/getGroupStatus`,
      data
    );
  },
  // 首页轮灌信息数据
  lgV3_getFirstScreenData: (data) => {
    return get(
      `/iotUser-api/v1/${
        typeIs18_23_24() ? "gatewayValveGroup3" : "gatewayValveGroup2"
      }/getFirstScreenData`,
      data
    );
  },
  // 设置分组
  lgV3_setGroup: (data) => {
    return post(
      `/iotUser-api/v1/${
        typeIs18_23_24() ? "gatewayValveGroup3" : "gatewayValveGroup2"
      }/settingGroup`,
      data
    );
  },
  // 读取分组
  lgV3_getGroup: (data, proId) => {
    return get(
      `/iotUser-api/v1/${
        typeIs18_23_24() ? "gatewayValveGroup3" : "gatewayValveGroup2"
      }/getGroup`,
      data
    );
  },
  // 园林控制器 type === 23  读取分组
  lgV4_getProgram_list: (data) =>
    post("/iotUser-api/v1/gatewayValveGroup4/settingGroup", data),
  // 园林控制器 type === 23  读取首屏数据
  lgV4_getFirstScreenData: (data) =>
    get("/iotUser-api/v1/gatewayValveGroup4/getFirstScreenData", data),

  // 设置分组
  lgV4_setGroup: (data) =>
    post("/iotUser-api/v1/gatewayValveGroup4/settingGroup", data),
  // 园林控制器 读取分组
  lgV4_getGroup: (data) =>
    get("/iotUser-api/v1/gatewayValveGroup4/getGroup", data),

  // 设置分组
  lgV5_setGroup: (data) =>
    post("/iotUser-api/v1/gatewayValveGroup5/settingGroup", data),
  // 园林控制器 读取分组
  lgV5_getGroup: (data) =>
    get("/iotUser-api/v1/gatewayValveGroup5/getGroup", data),

  // 园林控制器 type === 24  读取首屏数据
  lgV5_getFirstScreenData: (data) =>
    get("/iotUser-api/v1/gatewayValveGroup5/getFirstScreenData", data),

  //= ====================================================================
  //= ============================轮灌程序 V2 结束==========================
  //= ====================================================================

  // 图片病虫害识别
  scanImage: (data) => post("/iotUser-api/v1/diseases/discern", data),
  // 获取传感器（径距-index=43）日最大伸缩量
  maxFlexVolumeDate: (data) =>
    post("/iotUser-api/v1/maxFlexVolumeDate/list", data),
  // 生长期识别
  citrusClassification: (data) =>
    post("/iotUser-api/v1/baidu/citrusClassification", data),
  // 识别果实数量及位置
  checkFruitPosition: (data) =>
    post(
      `/iotUser-api/v1/imageRecognition/citrusClassification?${
        data.fileId ? `fileId=${data.fileId}` : ""
      }`,
      data
    ),
  // 生成ndvi 图片
  generateNDVI: (data) => get("/iotUser-api/v1/cameraImg/ndviDeal", data),
  // 获取点播设备的设备信息
  getVideoDeviceInfo: (data) => get("/iotUser-api/v1/video/deviceInfo", data),
  // 获取点播流地址
  getVideoDevicePlayURL: (data) =>
    get("/iotUser-api/v1/video/devicePlay", data),
  // 控制type=9 的监控设备的控制器
  ptzControl: (data) => post("/iotUser-api/v1/video/ptzControl", data),
  // 萤石云视频截图
  capture: (data) =>
    post("/iotUser-api/v1/ysVideo/capture", data, "post", {
      timeout: 60 * 1000,
    }),

  // RTU 编程
  // RTU 编程
  // RTU 编程
  // 读取设置数据
  rtu_getSetting: (data) =>
    post(`/iotUser-api/v1/program/readSetting?gatewayNo=${data}`, null),
  // 读取各个类型阀门的状态
  rtu_getValveStatus: (data) =>
    get("/iotUser-api/v1/program/readValveStatus", data),
  // 阀门控制开关
  rtu_control: (data) => post("/iotUser-api/v1/program/control", data),
  // 阀门编程设置
  rtu_setting: (data) => post("/iotUser-api/v1/program/setting", data),

  // 根部监测监控器视频控制
  // 获取第三方摄像头参数
  getThirdCamera: (data) => post("/iotUser-api/v1/ysVideo/getList", data),
  // 控制第三方摄像头
  ctrlCamera: (data) => post("/iotUser-api/v1/ysVideo/ptz", data),
  ctrlCamera22: (data) =>
    post("/iotUser-api/v1/ysVideoPreset/call-position", data),

  // 获取
  rootMonitor_getPoint: (data) =>
    post("/iotUser-api/v1/ysVideo/queryPreset", data),
  rootMonitor_getPoint22: (data) =>
    get(`/iotUser-api//v1/ysVideoPreset/list/${data.no}`, data),
  // 设置
  rootMonitor_putPoint: (data) =>
    post("/iotUser-api/v1/ysVideo/addPreset", data),
  rootMonitor_putPoint22: (data) =>
    post("/iotUser-api/v1/ysVideoPreset/add", data),

  rootMonitor_updatePoint22: (data) =>
    post(`/iotUser-api/v1/ysVideoPreset/update/${data.id}`, data),

  // 调用 /iotUser-api/v1/ysVideoPreset/call-preset/
  rootMonitor_postPoint: (data) =>
    post("/iotUser-api/v1/ysVideo/invokePreset", data),
  rootMonitor_postPoint22: (data) =>
    post(`/iotUser-api/v1/ysVideoPreset/call-preset/${data.id}`, data),

  // 删除
  rootMonitor_deletePoint: (data) =>
    post("/iotUser-api/v1/ysVideo/clearPreset", data),
  rootMonitor_deletePoint22: (data) =>
    post(`/iotUser-api/v1/ysVideoPreset/del/${data.id}`, data),

  /** *********************** 日志类 *************************/
  // 查询操作日志
  irrigationGroupLogOpList: ({ gatewayNo, page, pageSize }) =>
    get(`/iotUser-api/v1/irrigationGroupLog/opList/${gatewayNo}`, {
      page,
      pageSize,
    }),
  // 操作失败日志
  irrigationGroupLogFailList: ({ gatewayNo, page, pageSize }) =>
    get(`/iotUser-api/v1/irrigationGroupLog/failList/${gatewayNo}`, {
      page,
      pageSize,
    }),

  // 新一代传感器界面的UI
  // 获取地块信息
  queryFarm: (no) => get(`/iotUser-api/v1/farm/queryFarm/${no}`),
  setFarmExtData: (data) => post("/iotUser-api/v1/farm/saveFarmExtData", data),
  // 保存果茎计划
  savePlanFruit: (data) => post("/iotUser-api/v1/farm/savePlanFuit", data),
  // 查询果茎计划
  queryPlanFuit: (cropId) =>
    get(`/iotUser-api/v1/farm/queryPlanFuit/${cropId}`),
  // 删除果茎计划
  deletePlanFruit: (id) =>
    post(`/iotUser-api/v1/farm/deletePlanFuit/${id}`, null, "delete"),
  queryGrowPeriod: (cropClassId) =>
    get(`/iotUser-api/v1/farm/queryGrowPeriod/${cropClassId}`),
  // 查询传感器属性
  getCgqAttr: (data) => get("/iotUser-api/v1/gateway/attrList", data),
  // 查询单个传感器的上报统计数据
  getDataBySensor: (data) =>
    get(`/iotUser-api/v1/gateway/getDataBySensor/${data.no}`, {
      ...data,
      no: undefined,
    }),
  // 根部 type ===5  获取任务列表
  ysVideoTaskList: (gatewayNo) =>
    get(`/iotUser-api/v1/ysVideo/taskList/${gatewayNo}`),
  // 根部拍照任务  type ===5
  ysVideoSaveCaptureTask: (data) =>
    post("/iotUser-api//v1/ysVideo/saveCaptureTask", data),
  // type === 21  网络灌溉控制器 读取配置
  getGuanGaiKongZhiConfig: (no) =>
    get("/iotUser-api/v1/rtuGateway/getConfig", { gatewayNo: no }),
  // type === 21  网络灌溉控制器 读取阀门状态
  getGuanGaiKongZhiQiReadValveStatus: (data) =>
    get("/iotUser-api/v1/rtuGateway/readValveStatus", data),
  // type === 21  网络灌溉控制器 配置网关
  setGuanGaiKongZhiQiConfig: (data) =>
    post("/iotUser-api/v1/rtuGateway/config", data),
  // type === 21  网络灌溉控制器 控制阀门
  setGuanGaiKongZhiQiControl: (data) =>
    post("/iotUser-api/v1/rtuGateway/control", data),
  // 设备休眠  type === 21
  deviceSleep: (no) =>
    post(`/iotUser-api/v1/rtuGateway/deviceSleep?gatewayNo=${no}`),

  // 虫情设备 查询设备列表
  getInsectSituationDeviceList: () => get("/iotUser-api/v1/insect/deviceList"),
  // 虫情设备 查询某个设备下结果
  getInsectSituationDeviceResult: (data) =>
    get("/iotUser-api/v1/insect/resultList", data),
  // 查询设备虫情数据按日期
  getInsectDataDateTime: (data) =>
    get("/iotUser-api/v1/iot-insect/insectDataDatetime", data),
  // 设备虫情数据统计
  getInsectDataStatisticDateTime: (data) =>
    get("/iotUser-api/v1/iot-insect/insectDataStatisticDatetime", data),
  // 分页查询设备虫情数据
  getInsectDataByPage: (data) => get("/iotUser-api/v1/iot-insect/listPage"),
};

export default api;
